<template>
  <div class="orgchart-container">
    <div class="orgchart">
      <table>
        <tbody v-for="(item, index) in dataArray" :key="index">
          <div v-dragscroll class="orgchart-levelOne-container">
            <tr>
              <td colspan="8">
                <div class="node mainLevel" :id="item.id">
                  <div id="one" ref="chartHead" class="point"></div>
                  <div class="title level1" @click="collapseFirstNode">
                    <i class="fa fa-users symbol"></i>
                    <span>{{ item.name }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="nodes orgchart-secondLevel all-tree">
              <td colspan="2">
                <table class="orgchart-secondLevel__table">
                  <tbody>
                    <tr class="orgchart-secondLevel__tr">
                      <td
                        v-for="(el, levelTwoIndex) in item.children.slice(0, 2)"
                        :key="levelTwoIndex"
                        colspan="8"
                        :class="
                          levelTwoIndex == 0
                            ? 'first-element-align'
                            : 'second-element-align'
                        "
                      >
                        <div :id="el.id" class="node levelOne">
                          <div
                            @click="
                              collapseLevel3(el.children, el.id, levelTwoIndex)
                            "
                            :style="{
                              cursor:
                                el.children && el.children.length > 0
                                  ? 'pointer'
                                  : null,
                            }"
                            class="title level2"
                          >
                            <i class="fa fa-users symbol"></i>
                            <span>{{ el.name }}</span>
                          </div>
                        </div>
                        <tr class="nodes orgchart-thirdLevel">
                          <td colspan="2">
                            <table>
                              <tbody>
                                <tr
                                  class="orgchart-thirdLevel__tr"
                                  :style="{
                                    alignItems:
                                      levelTwoIndex == 0
                                        ? 'flex-end'
                                        : 'flex-start',
                                  }"
                                  :class="
                                    levelTwoIndex == 0
                                      ? 'tr-end-border'
                                      : 'tr-start-border'
                                  "
                                >
                                  <td
                                    v-for="(el2, i) in el.children"
                                    :key="i"
                                    :style="{
                                      flexDirection:
                                        levelTwoIndex == 0
                                          ? 'row-reverse'
                                          : 'row',
                                    }"
                                    class="orgchart-thirdLevel__td td-dash"
                                  >
                                    <div
                                      @click="
                                        el2.children && el2.children.length > 0
                                          ? collapseLevel4(
                                              el2.id,
                                              el2.children,
                                              levelTwoIndex
                                            )
                                          : null
                                      "
                                      :id="el2.id"
                                      class="node levelThree no-before p-0"
                                      :style="{
                                        cursor:
                                          el2.children &&
                                          el2.children.length > 0
                                            ? 'pointer'
                                            : null,
                                      }"
                                      :class="
                                        el2.children && el2.children.length > 0
                                          ? 'levelTwo'
                                          : null
                                      "
                                    >
                                      <div class="title level3">
                                        <i class="fa fa-users symbol"></i>
                                        <span>{{ el2.name }}</span>
                                      </div>
                                    </div>
                                    <tr
                                      class="nodes orgchart-fourthLevel"
                                      :style="{
                                        margin:
                                          levelTwoIndex == 0
                                            ? '-30px 0 0 30px'
                                            : '-30px 30px 0 0',
                                      }"
                                    >
                                      <td colspan="2">
                                        <table>
                                          <tbody>
                                            <tr
                                              class="orgchart-fourthLevel__tr"
                                              :class="
                                                levelTwoIndex == 0
                                                  ? 'tr-border-left'
                                                  : 'tr-border-right'
                                              "
                                              v-show="expandLastLevel"
                                            >
                                              <td
                                                v-for="(el3,
                                                ind) in el2.children"
                                                :key="ind"
                                                :class="
                                                  el3.item
                                                    ? 'td-dash-level3'
                                                    : null
                                                "
                                              >
                                                <div
                                                  :id="ind"
                                                  class="node levelFour"
                                                >
                                                  <div class="title level4">
                                                    <i
                                                      class="fa fa-users symbol"
                                                    ></i>
                                                    <span>{{ el3.item }}</span>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </div>

          <tr v-dragscroll class="nodes orgchart-levelTwo-container">
            <div ref="chartChildren" id="two" class="point"></div>
            <td colspan="2" class="orgchart-levelTwo-container__td">
              <table>
                <tbody>
                  <tr>
                    <td
                      v-for="(el, index) in item.children.slice(
                        2,
                        item.children.length
                      )"
                      :key="index"
                      colspan="8"
                      class="td-down-elements"
                    >
                      <div
                        :id="el.id"
                        @click="collapseLevel3(el.children, el.id)"
                        class="node td-down-elements__node"
                        :style="{
                          cursor:
                            el.children && el.children.length > 0
                              ? 'pointer'
                              : null,
                        }"
                      >
                        <div class="title level2">
                          <i class="fa fa-users symbol"></i>
                          <span>{{ el.name }}</span>
                        </div>
                      </div>
                      <tr class="nodes orgchart-levelTwo-container-levelTwo">
                        <td colspan="2">
                          <table>
                            <tbody>
                              <tr>
                                <td
                                  v-for="(el2, index) in el.children"
                                  :key="index"
                                  class="orgchart-levelTwo-container-levelTwo__td"
                                >
                                  <div
                                    @click="
                                      el2.children
                                        ? collapseChildrenLevel4(
                                            el2.id,
                                            el2.children
                                          )
                                        : null
                                    "
                                    :id="el2.id"
                                    class="node levelTwoChildren"
                                    :style="{
                                      cursor:
                                        el2.children && el2.children.length > 0
                                          ? 'pointer'
                                          : null,
                                    }"
                                  >
                                    <div class="title level3">
                                      <i class="fa fa-users symbol"></i>
                                      <span>{{ el2.name }}</span>
                                    </div>
                                  </div>
                                  <tr
                                    class="nodes orgchart-levelTwo-container-levelThree"
                                  >
                                    <td colspan="2">
                                      <table>
                                        <tbody>
                                          <tr v-show="expandChildrenLastLevel">
                                            <td
                                              v-for="(el3,
                                              index) in el2.children"
                                              :key="index"
                                              class="orgchart-levelTwo-container-levelThree__td"
                                            >
                                              <div :id="index" class="node">
                                                <div class="title level4">
                                                  <i
                                                    class="fa fa-users symbol"
                                                  ></i>
                                                  <span>{{ el3.item }}</span>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { elementIsRendered } from "./elementIsRendered.js"
import { dragscroll } from 'vue-dragscroll'

export default {
  props: ["OrgChartModel"],
  directives: {
    'dragscroll': dragscroll
  },
  data() {
    return {
      ds: {},
      dataArray: [],
      expandLastLevel: false,
      expandChildrenLastLevel: false,
    };
  },
  updated() {
    // move second level while scrolling first level
    elementIsRendered(".orgchart-levelOne-container").then((el) => {
      el.addEventListener("scroll", () => {
        const target = document.querySelector(".point");
        const childNodes = document.querySelector(
          ".orgchart-levelTwo-container"
        );
        if(window.innerWidth > 400) {
          if (target.getBoundingClientRect().left > 600) {
          childNodes.scroll({
            left: -target.getBoundingClientRect().left - 200,
            //behavior: "smooth",
          });
        } else if (target.getBoundingClientRect().left < 500) {
          childNodes.scroll({
            left: target.getBoundingClientRect().left,
            //behavior: "smooth",
          });
        }
        } else {
            if (target.getBoundingClientRect().left > 200) {
          childNodes.scroll({
            left: -target.getBoundingClientRect().left - 200,
            //behavior: "smooth",
          });
        } else if (target.getBoundingClientRect().left < 150) {
          childNodes.scroll({
            left: target.getBoundingClientRect().left,
            //behavior: "smooth",
          });
        }
        }
      });
    });

  },
  methods: {
    drag() {
      // The current position of mouse
      let x = 0;
      let y = 0;

      // Query the element
      const ele = document.querySelector(".orgchart-levelOne-container");

      // Handle the mousedown event
      // that's triggered when user drags the element
      const mouseDownHandler = function(e) {
        // Get the current mouse position
        x = e.clientX;
        y = e.clientY;

        // Attach the listeners to `document`
        document.addEventListener("scroll", mouseMoveHandler);
        document.addEventListener("mouseup", mouseUpHandler);
      };

      const mouseMoveHandler = function(e) {
        // How far the mouse has been moved
        const dx = e.clientX - x;
        const dy = e.clientY - y;

        // Set the position of element
        ele.style.top = `${ele.offsetTop + dy}px`;
        ele.style.left = `${ele.offsetLeft + dx}px`;

        // Reassign the position of mouse
        x = e.clientX;
        y = e.clientY;
      };

      const mouseUpHandler = function() {
        // Remove the handlers of `mousemove` and `mouseup`
        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
      };

      ele.addEventListener("mousedown", mouseDownHandler);
    },
    drawConnectingLine() {
      // Draw line from first node to children
      const lineElement = document.querySelector(".point");
      elementIsRendered(".orgchart-secondLevel").then(() => {
        const calculateLineHeight = () => {
          return document.querySelector(".orgchart-secondLevel").clientHeight;
        };
        lineElement.style.setProperty(
          "--height",
          `${calculateLineHeight() + 50}px`
        );
      });
    },
    scrollIntoView(selector, block, inline) {
      document
        .querySelector(selector)
        .scrollIntoView({ block: block, inline: inline });
    },
    addClassFunction(selector, className) {
      document.querySelector(selector).classList.add(className);
    },
    collapseFirstNode() {
      document.querySelectorAll(".all-tree, .orgchart-levelTwo-container, .orgchart-levelTwo-container__td , #one").forEach(el => el.classList.toggle("d-none"));
      document.querySelector(" .orgchart-levelOne-container").classList.toggle("p-0")
    },
    collapseLevel3(children, id, index) {
      const firstNode = document
        .querySelector(".first-element-align")
        .classList.contains("min-width");
      const secondNode = document
        .querySelector(".second-element-align")
        .classList.contains("min-width");
      const nodesContainer = document.querySelector(
        ".orgchart-levelOne-container"
      );

      if (!firstNode || !secondNode) {
        nodesContainer.scrollTo(-1000, 0);
      }

      this.expandLastLevel = false;
      if (index == 0 || index == 1) {
        this.addClassFunction(".first-element-align", "min-width");
        this.addClassFunction(".second-element-align", "min-width");
      }
      this.addClassFunction(".mainLevel", "edit-after");
      const levelThreeBefore = Array.from(
        document.querySelectorAll(".levelThree")
      );
      levelThreeBefore.map((item) => {
        item.classList.add("no-before");
      });
      children.map((el) => {
        const levelThreeChildren = document.getElementById(el.id).nextSibling;
        if (
          document.getElementById(el.id).style.display == "none" &&
          children
        ) {
          document.getElementById(el.id).style.display = "block";
          levelThreeChildren.style.display = "block";
          document.getElementById(id).nextSibling.style.display = "block";
          document.getElementById(id).classList.remove("no-after");
        } else {
          document.getElementById(id).classList.add("no-after");
          document.getElementById(el.id).style.display = "none";
          levelThreeChildren.style.display = "none";
          document.getElementById(id).nextSibling.style.display = "none";
        }
        // Draw line from first node to children
        this.drawConnectingLine();
      });
    },

    collapseLevel4(id, children, index) {
      this.addClassFunction(".mainLevel", "edit-after");
      if (index == 0) {
        elementIsRendered(".tr-border-left").then(() => {
          this.scrollIntoView(".tr-border-left", "start", "center");
        });
      } else if (index == 1) {
        elementIsRendered(".tr-border-right").then(() => {
          this.scrollIntoView(".tr-border-right", "start", "center");
        });
      }
      if (index == 0 || index == 1) {
        this.addClassFunction(".first-element-align", "min-width");
        this.addClassFunction(".second-element-align", "min-width");
      }
      const levelFourItems = document.getElementById(id).nextSibling;
      const levelThreeBefore = Array.from(
        document.querySelectorAll(".levelThree")
      );
      const unselectedLevelThreeBefore = levelThreeBefore.filter(
        (item) => item.id != id
      );

      const unselectedChildren = Array.from(
        document.getElementsByClassName("levelTwo")
      ).filter((div) => div.id != id);
      unselectedChildren.map((el) => {
        el.nextSibling.style.display = "none";
      });

      if (
        levelFourItems.style.display == "none" &&
        children &&
        this.expandLastLevel == true
      ) {
        document.getElementById(id).classList.remove("no-before");
        levelFourItems.style.display = "block";
        unselectedLevelThreeBefore.map((el) => {
          el.classList.add("no-before");
        });
      } else if (this.expandLastLevel == false) {
        this.expandLastLevel = true;
        document.getElementById(id).classList.remove("no-before");
        levelFourItems.style.display = "block";
      } else {
        unselectedLevelThreeBefore.map((el) => {
          el.classList.add("no-before");
        });
        levelFourItems.style.display = "none";
        document.getElementById(id).classList.add("no-before");
      }

      // Draw line from first node to children
      this.drawConnectingLine();
    },

    collapseChildrenLevel4(id, children) {
      const levelFourItems = document.getElementById(id).nextSibling;
      if (
        levelFourItems.style.display == "none" &&
        children &&
        this.expandChildrenLastLevel == true
      ) {
        levelFourItems.style.display = "block";
      } else if (this.expandChildrenLastLevel == false) {
        this.expandChildrenLastLevel = true;
        const unselectedChildren = Array.from(
          document.getElementsByClassName("levelTwoChildren")
        ).filter((div) => div.id != id);
        unselectedChildren.map((el) => {
          el.nextSibling.style.display = "none";
        });
      } else {
        levelFourItems.style.display = "none";
      }
    },
    getHeadNode() {
      return this.$refs;
    },
  },
  mounted() {
    // handling org chart data object
    const dataArray = [];
    dataArray.push(JSON.parse(this.OrgChartModel));
    dataArray.map((item) => {
      this.ds = {
        id: item.Id,
        name: item.Title,
        IsExpanded: item.IsExpanded,
        level: 1,
        children: item.MainTitles.map((item) => {
          return {
            id: item.Id,
            name: item.Title,
            IsExpanded: item.IsExpanded,
            level: 2,
            children: item.SubItems.map((item) => {
              return {
                id: item.Id,
                name: item.Title,
                IsExpanded: item.IsExpanded,
                level: 3,
                children: item.ListOfStrings
                  ? item.ListOfStrings.map((item) => {
                      return {
                        item,
                      };
                    })
                  : null,
              };
            }),
          };
        }),
      };
    });
    this.dataArray.push(this.ds);

    // calculate children height on mounted to draw connecting line
    elementIsRendered(".orgchart-secondLevel").then(() => {
      this.drawConnectingLine();
    });

    // scroll into view
    elementIsRendered(".point").then((el) => {
      el.scrollIntoView({ block: "start", inline: "center" });
      window.scrollTo(0, 0);
    });

    elementIsRendered("#two").then((el) => {
      el.scrollIntoView({ block: "start", inline: "center" });
      window.scrollTo(0, 0);
    });
  },
};
</script>
